/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Invite_DismissInputs */

const en_us2_body_assessment_invite_dismiss = /** @type {(inputs: Body_Assessment_Invite_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

const pt_br2_body_assessment_invite_dismiss = /** @type {(inputs: Body_Assessment_Invite_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora não`)
};

const es_419_body_assessment_invite_dismiss = /** @type {(inputs: Body_Assessment_Invite_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora no`)
};

const pt_pt2_body_assessment_invite_dismiss = /** @type {(inputs: Body_Assessment_Invite_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora não`)
};

const fr_fr2_body_assessment_invite_dismiss = /** @type {(inputs: Body_Assessment_Invite_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas maintenant`)
};

const de_de2_body_assessment_invite_dismiss = /** @type {(inputs: Body_Assessment_Invite_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht jetzt`)
};

const it_it2_body_assessment_invite_dismiss = /** @type {(inputs: Body_Assessment_Invite_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ora`)
};

/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Body_Assessment_Invite_DismissInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_invite_dismiss = /** @type {((inputs?: Body_Assessment_Invite_DismissInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Invite_DismissInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_invite_dismiss(inputs)
	if (locale === "es-419") return es_419_body_assessment_invite_dismiss(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_invite_dismiss(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_invite_dismiss(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_invite_dismiss(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_invite_dismiss(inputs)
	return en_us2_body_assessment_invite_dismiss(inputs)
});
export { body_assessment_invite_dismiss as "body-assessment.invite_dismiss" }